exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider__slide[data-v-d81f054e]{min-width:100%;height:100%;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 100%;flex:1 100%;border-radius:12px}.slider__body[data-v-d81f054e]{min-width:auto;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;-webkit-transition:all .5s ease;transition:all .5s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d81f054e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/elements/ClientReviewSlider.vue
// module id = WtnA
// module chunks = 2